import React from 'react';
import { AlertTriangle, Banknote, Landmark, ReceiptText, Scale, Users } from 'lucide-react';
import { fmtEur } from './reconciliationUtils';

const Metric = ({ testId, label, value, icon: Icon, tone = 'slate' }) => {
  const tones = {
    slate: 'border-slate-200 text-slate-900',
    sky: 'border-sky-200 text-sky-800',
    emerald: 'border-emerald-200 text-emerald-800',
    amber: 'border-amber-200 text-amber-800',
    red: 'border-red-200 text-red-800',
  };
  return (
    <div className={`min-w-0 border-l-2 pl-3 py-1 ${tones[tone]}`} data-testid={testId}>
      <div className="flex items-center gap-1.5 text-[11px] font-semibold uppercase text-slate-500">
        <Icon className="h-3.5 w-3.5 shrink-0" /> <span className="truncate">{label}</span>
      </div>
      <div className="mt-1 font-mono text-xl font-bold tabular-nums break-words">{value}</div>
    </div>
  );
};

export const ReconciliationSummaryBar = ({ summary }) => {
  const variance = Number(summary.net_variance || 0);
  return (
    <section className="border-y border-slate-200 bg-white px-4 py-4" data-testid="reconciliation-summary-bar">
      <div className="grid grid-cols-2 gap-5 md:grid-cols-3 xl:grid-cols-6">
        <Metric testId="metric-total-positions" label="Posizioni" value={summary.total_items || 0} icon={Users} />
        <Metric testId="metric-total-collected" label="Incassato ospiti" value={fmtEur(summary.total_collected)} icon={Banknote} tone="sky" />
        <Metric testId="metric-total-due" label="Dovuto da regole" value={fmtEur(summary.total_due)} icon={Scale} tone="amber" />
        <Metric testId="metric-total-declared" label="Dichiarato" value={fmtEur(summary.total_declared)} icon={Landmark} />
        <Metric testId="metric-total-paid" label="Versato" value={fmtEur(summary.total_paid)} icon={ReceiptText} tone="emerald" />
        <Metric testId="metric-net-variance" label="Scostamento netto" value={fmtEur(variance)} icon={AlertTriangle} tone={Math.abs(variance) > 50 ? 'red' : 'emerald'} />
      </div>
      <div className="mt-3 flex flex-wrap gap-2 text-xs" data-testid="reconciliation-anomaly-counts">
        <span className="border border-red-200 bg-red-50 px-2 py-1 font-medium text-red-800" data-testid="critical-anomalies-count">
          {summary.critical_count || 0} critiche
        </span>
        <span className="border border-amber-200 bg-amber-50 px-2 py-1 font-medium text-amber-800" data-testid="open-anomalies-count">
          {summary.anomalies_count || 0} anomalie operative
        </span>
      </div>
    </section>
  );
};